import { render } from "./WhySogdoItsInnovationComp.vue?vue&type=template&id=1c001784&scoped=true"
import script from "./WhySogdoItsInnovationComp.vue?vue&type=script&lang=js"
export * from "./WhySogdoItsInnovationComp.vue?vue&type=script&lang=js"

import "./WhySogdoItsInnovationComp.vue?vue&type=style&index=0&id=1c001784&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c001784"]])

export default __exports__